import ThemeMaker from "../../components/thememaker";
import ImageAdd from "../../components/ImageAdd/ImageAdd";
import { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../utils/config";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const Variants = () => {
    const { apiEndpoint, awsKeyId, awsSecretKey, awsRegion, awsBucket, baseNodeapiUrl } = config;
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const variantId = queryParams.get("variantId")
    const product_type_id = queryParams.get("product_type_id")
    const category_id = queryParams.get("category_id")
    const [product, setProduct] = useState({
        image: [],
        returnable: "true",
        cancelable: "true",
        return_window: "P7D",
        seller_pickup_return: "true",
        time_to_ship: "P2D",
        replaceable: "true",
    });
    // const [brandlist, setbrandlist] = useState([]);
    const timeToShipLength = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15);
    const returnWindowLength = new Array(1, 2, 3, 4, 5, 6, 7, 8, 9, 10);
    const [isLoading, setIsLoading] = useState(false);
    const rawDataError = {
        name: false,
        category_id: false,
        short_description: false,
        description: false,
        quantity: false,
        maximum_price: false,
        selling_price: false,
        image: false,
        returnable: false,
        cancelable: false,
        return_window: false,
        seller_pickup_return: false,
        time_to_ship: false,
        product_type: false,
        gtin: false,
        uom: false,
        replaceable: false,
        weight: false
    };
    const [productErr, setProductErr] = useState(rawDataError);



    const getHexValue = async (color) => {
        console.log("colorcolorcolor ---->", color);
        try {
            const response = await axios.get(
                `https://api.color.pizza/v1/names/?name=${color}`
            );
            const hexValue = response?.data?.colors?.length
                ? response.data.colors[0].hex
                : "";
            return hexValue;
        } catch (error) {
            console.log("Error ----->", error);
            return "";
        }
    };

    useEffect(() => {
        if (product?.colour) {
            getHexValue(product.colour);
        }

        getMandAttribute()


    }, [])

    const productId = queryParams.get("productId");

    const createPayload = async () => {
        let colourName = manDatoryAttrKeyValue.find((item) => item.attribute_name === "colour")
        const hexValue = await getHexValue(colourName?.attribute_value);
        const payload = {
            product_id: productId || variants?.[0]?.product?.id,
            variants: [
                {
                    variation_id: variantId ? variantId : "",
                    gtin: product.gtin,
                    image: product.image?.[0],
                    uom: product.uom,
                    max_quantity: 2,
                    min_quantity: 1,
                    price: {
                        base_price: Number(product.maximum_price),
                        minimum_price: Number(product.minimum_price),
                        maximum_price: Number(product.maximum_price)
                    },

                    inventories: [
                        {
                            warehouse_id: 8,
                            quantity: Number(product.quantity || 10)
                        }
                    ],

                    fulfillments: {
                        return_window: product.return_window,
                        time_to_ship: product.time_to_ship,
                        returnable: product.returnable === "true",
                        cancellable: product.cancelable === "true",
                        seller_pickup_return: product.seller_pickup_return === "true",
                        replaceable: product.replaceable === "true"
                    },
                    "packing_details": {
                        "price": {
                            "unit": "INR",
                            "value": product?.packing_price
                        },
                        "height": {
                            "unit": "centimeter",
                            "value": product?.height
                        },
                        "length": {
                            "unit": "centimeter",
                            "value": product?.length
                        },
                        "weight": {
                            "unit": product.uom,
                            "value": Number(product.weight)
                        },
                        "breadth": {
                            "unit": "centimeter",
                            "value": product?.breadth
                        },
                        "category": product?.category_name,
                        "dangerous_goods": product?.dangerous_goods
                    },
                    attributes: manDatoryAttrKeyValue.map((item) =>
                        item.attribute_name === "colour"
                            ? { ...item, attribute_value: hexValue }
                            : item
                    )
                }
            ]
        };
        return payload;
    };

    // async function brandlisting() {
    //     try {
    //         const { data } = await axios({
    //             url: `${apiEndpoint}/getBrandList`,
    //             method: "POST",
    //             headers: {
    //                 "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
    //             },
    //         })
    //         if (data.status === 200) {
    //             setbrandlist(data.data)
    //         }
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    // useEffect(() => {
    //     brandlisting();
    // }, []);

    const productImageHandler = async (e) => {
        const files = e.target.files;
        if (!files || files.length === 0) {
            alert("Please select file(s) first!");
            return;
        }
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]);
        }
        try {
            const { data } = await axios.post(
                `${baseNodeapiUrl}/upload`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`,
                    }
                }
            );

            if (data?.success) {
                toast.success(data.message || "Upload successful!");
                console.log("Uploaded URLs:", data.urls);

                setProduct((prevProduct) => ({
                    ...prevProduct,
                    image: [...prevProduct.image, ...data.urls]
                }));

            } else {
                toast.error("Upload failed!");
            }

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed!");
        }
    };

    function removeImageHandler(index, removeImageHandler) {
        // alert(index);
        let z = [...product.image]
        z.splice(index, 1)
        setProduct({ ...product, image: [...z] })
    }

    const errorHandler = (e) => {
        if (e.target.value) {
            setProductErr({ ...productErr, [e.target.name]: false });
        } else {
            setProductErr({ ...productErr, [e.target.name]: true });
        }
    };

    const [variants, setVariants] = useState([]);

    const fetchVariants = async () => {
        try {
            const response = await axios({
                url: `${apiEndpoint}/list-variant`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    variant_id: variantId
                }
            });
            setVariants(response?.data?.data);
            const variantData = response?.data?.data?.[0]?.variants?.[0];
            if (variantData) {
                const features = variantData.features || {};
                const fulfillments = variantData.fulfillments || {};
                const prices = variantData.prices?.[0] || {};
                let attributeData = {};
                if (variantData.attributes?.length) {
                    variantData.attributes.forEach((item) => {
                        attributeData[item.attribute_name] = item.attribute_value;
                    });
                }
                console.log("attributeDataattributeData ------->", attributeData);
                console.log("variantData?.packing_details ------->", variantData?.packing_details?.height?.value);
                setProduct((prev) => ({
                    ...prev,
                    gtin: variantData.gtin,
                    height: variantData?.packing_details?.height?.value,
                    length: variantData?.packing_details?.length?.value,
                    breadth: variantData?.packing_details?.breadth?.value,
                    packing_price: variantData?.packing_details?.price?.value,
                    dangerous_goods: variantData?.packing_details?.dangerous_goods,
                    category_name: variantData?.packing_details?.category,
                    uom: variantData.uom,
                    image: [variantData.image],
                    weight: features.weight,
                    // height: features.height,
                    // length: features.length,
                    // breadth: features.breadth,
                    colour: features.colour,
                    os_type: features.os_type,
                    ram_unit: features.ram_unit,
                    storage_unit: features.storage_unit,
                    minimum_price: prices.minimum_price,
                    maximum_price: prices.maximum_price,
                    return_window: fulfillments.return_window
                        ? fulfillments.return_window.replace("PP", "P").replace("DD", "D")
                        : "",
                    time_to_ship: fulfillments.time_to_ship
                        ? fulfillments.time_to_ship.replace("PP", "P").replace("DD", "D")
                        : "",
                    returnable: String(fulfillments.returnable),
                    cancelable: String(fulfillments.cancellable),
                    seller_pickup_return: String(fulfillments.seller_pickup_return),
                    replaceable: String(fulfillments.replaceable),
                    ...attributeData
                }));

                let t = variantData?.attributes?.map(item => {
                    return {
                        attribute_name: item.attribute_name,
                        attribute_value: item.attribute_value
                    }
                })
                let z = Object.entries(variantData?.features || {}).map(
                    ([key, value]) => ({
                        attribute_name: key,
                        attribute_value: value
                    })
                );

                setmanDatoryAttrKeyValue([...z, ...t])
                // setmanDatoryAttr([...z, ...t])
                console.log("productproduct ---->", product);
            }
            console.log("response variants ---------->", variants);
        } catch (error) {
            console.error("Error fetching variants:", error);
        }
    };
    console.log(product)
    useEffect(() => {
        if (variantId) {
            fetchVariants();
        }
    }, [])

    async function updateVarintHnadler() {
        setIsLoading(true);
        const payload = await createPayload();
        console.log("payloadpayload ----->", payload);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/add-update-variant`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    ...payload,
                }
            })
            setIsLoading(false);
            toast.success(data.message);
        } catch (err) {
            setIsLoading(false);
            const errorMessage = err?.response?.data?.message || "Something went wrong";
            toast.error(errorMessage);
            console.log(err)
        }
    }
    const [manDatoryAttr, setmanDatoryAttr] = useState([]);
    const [manDatoryAttrKeyValue, setmanDatoryAttrKeyValue] = useState([])
    console.log(manDatoryAttrKeyValue)
    async function getMandAttribute(value, parent_category_id) {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/listmandattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                data: {
                    "parent_category_id": category_id,
                    "product_type_id": product_type_id
                }
            })
            if (data?.status == "200") {
                setmanDatoryAttr(data?.response);

                setmanDatoryAttrKeyValue(data?.response?.map(item => {
                    return {
                        attribute_name: item.mandatory_attribute,
                        attribute_value: ""
                    }
                }));
            }
        } catch (err) {
            toast.error("Server not working, please try later!")
            console.log(err)
        }

    }

    function attributeChangeHanndler(e, name) {

        let t = [...manDatoryAttrKeyValue];
        let y = t.findIndex(item => item.attribute_name === name);
        t[y] = { attribute_name: name, attribute_value: e.target.value }

        setmanDatoryAttrKeyValue(t)

    }

    return (
        <ThemeMaker>
            <div>
                <div className="container mt-3">
                    <div className="card">
                        <div className="card-body" style={{ height: "80vh", overflow: "scroll" }}>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className='genericlabel'>GTIN</label>
                                    <span className="text-danger"> * </span>
                                    <input
                                        type="text"
                                        name="gtin"
                                        value={product.gtin || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                        className="form-control"
                                        placeholder="Enter GTIN"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <ImageAdd
                                            productImageHandler={productImageHandler}
                                            productData={product}
                                            imageIndex={1}
                                            removeImageHandler={removeImageHandler}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Unit Of Measurement (UOM)</label>
                                        <span className="text-danger"> * </span>
                                        <select
                                            name="uom"
                                            className="form-control"
                                            value={product.uom || ""}
                                            onChange={(e) =>
                                                setProduct({ ...product, [e.target.name]: e.target.value })
                                            }
                                            onBlur={(e) => errorHandler(e)}
                                        >
                                            <option value="">Select UOM</option>
                                            <option value="dozen">Dozen</option>
                                            <option value="gram">Gram</option>
                                            <option value="kilogram">Kilogram</option>
                                            <option value="tonne">Ton</option>
                                            <option value="litre">Litre</option>
                                            <option value="millilitre">Millilitre</option>
                                            <option value="unit">Unit</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <label className='genericlabel'>Weight</label>
                                    <span className="text-danger"> * </span>

                                    <input
                                        type="text"
                                        name="weight"
                                        value={product.weight ?? ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                        className="form-control"
                                        placeholder="Enter Weight"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className='genericlabel'>Product Return Window</label>
                                    <span className="text-danger"> * </span>
                                    <select
                                        className="form-control"
                                        name="return_window"
                                        value={product.return_window || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Select Return Window</option>
                                        {returnWindowLength.map((item, index) => (
                                            <option value={`P${item}D`} key={index}>
                                                {item === 1 ? `${item} Day` : `${item} Days`}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6">
                                    <label className='genericlabel'>Time To Ship</label>
                                    <span className="text-danger"> * </span>

                                    <select
                                        className="form-control"
                                        name="time_to_ship"
                                        value={product.time_to_ship || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Time To Ship</option>
                                        {timeToShipLength.map((item, index) => (
                                            <option value={`P${item}D`} key={index}>
                                                {item === 1 ? `${item} Day` : `${item} Days`}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label className='genericlabel'>Product Returnable</label>
                                    <span className="text-danger"> * </span>
                                    <select
                                        className="form-control"
                                        name="returnable"
                                        value={product?.returnable || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Product Returnable</option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label className='genericlabel'>Product Cancellable</label>
                                    <span className="text-danger"> * </span>
                                    <select
                                        className="form-control"
                                        name="cancelable"
                                        value={product.cancelable || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Select Cancellable</option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label className='genericlabel'>Return Pickup Available</label>
                                    <span className="text-danger"> * </span>

                                    <select
                                        className="form-control"
                                        name="seller_pickup_return"
                                        value={product.seller_pickup_return || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Select Return Pickup</option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <label className='genericlabel'>Product Replaceable</label>
                                    <span className="text-danger"> * </span>

                                    <select
                                        className="form-control"
                                        name="replaceable"
                                        value={product.replaceable || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                    >
                                        <option value="">Select Product Replaceable</option>
                                        <option value={"true"}>Yes</option>
                                        <option value={"false"}>No</option>
                                    </select>
                                </div>
                            </div>

                            <span className="text-dark fs-5 mt-3" style={{ fontWeight: "bold" }}>
                                Price
                            </span>

                            <div className="row mt-2 mb-3">
                                <div className="col-md-4">
                                    <label className='genericlabel'>Base/Selling price</label>
                                    <span className="text-danger"> * </span>
                                    <input
                                        type="number"
                                        name="base_price"
                                        value={product.base_price || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                        className="form-control"
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className='genericlabel'>MRP</label>
                                    <span className="text-danger"> * </span>
                                    <input
                                        type="number"
                                        name="maximum_price"
                                        value={product.maximum_price || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className='genericlabel'>Min Price</label>
                                    <span className="text-danger"> * </span>
                                    <input
                                        type="number"
                                        name="minimum_price"
                                        value={product.minimum_price || ""}
                                        onChange={(e) =>
                                            setProduct({ ...product, [e.target.name]: e.target.value })
                                        }
                                        className="form-control"
                                    />
                                </div>

                            </div>
                            <span className="text-dark mb-3 fs-5" style={{ fontWeight: "bold" }}>
                                Dimesions
                            </span>
                            <div className="col-md-12 row">




                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Packing price</label>
                                        <span className="text-danger" > * </span>

                                        <input type="number" className="form-control" id=""
                                            name="packing_price" value={product?.packing_price} onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} placeholder="Enter packing price" onBlur={(e) => errorHandler(e)}

                                        />
                                        {
                                            productErr?.weight ? (
                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                            ) : null
                                        }
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Product Height (in cm)</label>
                                        <span className="text-danger" > * </span>

                                        <input type="number" className="form-control" id=""
                                            name="height" value={product?.height} onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} placeholder="Enter height" onBlur={(e) => errorHandler(e)}

                                        />
                                        {
                                            productErr?.weight ? (
                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                            ) : null
                                        }
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Product length (in cm)</label>
                                        <span className="text-danger" > * </span>

                                        <input type="number" className="form-control" id=""
                                            name="length" value={product?.length} onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} placeholder="Enter length" onBlur={(e) => errorHandler(e)}

                                        />
                                        {
                                            productErr?.weight ? (
                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                            ) : null
                                        }
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Product breadth (in cm)</label>
                                        <span className="text-danger" > * </span>

                                        <input type="number" className="form-control" id=""
                                            name="breadth" value={product?.breadth} onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} placeholder="Enter breadth" onBlur={(e) => errorHandler(e)}

                                        />
                                        {
                                            productErr?.weight ? (
                                                <span className="text-danger tiny_size" > This field is required ! </span>
                                            ) : null
                                        }
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className='genericlabel'>Handle with care</label>

                                        <select className="form-control" value={product?.dangerous_goods} name="dangerous_goods" onChange={(e) => setProduct({
                                            ...product, [e.target.name]: e.target.value,
                                        })} onBlur={(e) => errorHandler(e)}
                                        >
                                            <option value="" disabled selected>Select</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <span className="text-dark mb-3 fs-5" style={{ fontWeight: "bold" }}>
                                Attributes
                            </span>

                            <div className="row mt-2 mb-3">

                                {
                                    manDatoryAttr?.filter(i => i.mandatory_attribute !== "colour")?.filter(i => i.is_mandate)?.map((item, index) => {
                                        return (
                                            <div className="col-md-4" key={item.mandatory_attribute || index}>
                                                <label
                                                    className='genericlabel'
                                                    style={{ textTransform: "capitalize" }}
                                                >
                                                    {item?.mandatory_attribute}
                                                </label>

                                                {item?.is_mandate && <span className="text-danger"> * </span>}

                                                <input
                                                    type="text"
                                                    name={item?.mandatory_attribute}
                                                    className="form-control"
                                                    value={manDatoryAttrKeyValue?.find(i => i.attribute_name === item?.mandatory_attribute)?.attribute_value || ""}
                                                    onChange={(e) => { attributeChangeHanndler(e, item?.mandatory_attribute) }}
                                                />
                                            </div>
                                        );
                                    })
                                }

                                {
                                    manDatoryAttr?.filter(i => i.mandatory_attribute !== "colour")?.filter(i => !i.is_mandate)?.map((item, index) => {
                                        return (
                                            <div className="col-md-4" key={item.mandatory_attribute || index}>
                                                <label
                                                    className='genericlabel'
                                                    style={{ textTransform: "capitalize" }}
                                                >
                                                    {item?.mandatory_attribute}
                                                </label>

                                                {item?.is_mandate && <span className="text-danger"> * </span>}

                                                <input
                                                    type="text"
                                                    name={item?.mandatory_attribute}
                                                    className="form-control"
                                                    value={manDatoryAttrKeyValue?.find(i => i.attribute_name === item?.mandatory_attribute)?.attribute_value || ""}
                                                    onChange={(e) => { attributeChangeHanndler(e, item?.mandatory_attribute) }}
                                                />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            <div className="d-flex justify-content-end">
                                <button className="btn btn-primary mt-3" onClick={updateVarintHnadler} disabled={isLoading}>
                                    {isLoading ? "Processing..." : variantId ? "Update Variant" : "Add Variant"}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </ThemeMaker>
    );
};

export default Variants;